export const addressEn = {
    street: 'Address',
    street2: 'Additionnal 1',
    street3: 'Additionnal2',
    zipCode: 'Zip code',
    city: 'City',
    country: 'Country'
}
